"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestInterSchema = exports.PaymentInterSchema = void 0;
const zod_1 = require("zod");
const string_fns_1 = require("./utils/string.fns");
const common_1 = require("./common");
const back_code_1 = require("./utils/back-code");
const InterApiContextSchema = zod_1.z.object({
    certificatePem: zod_1.z.string().min(1),
    privateKeyPem: zod_1.z.string().min(1),
    clientId: zod_1.z.string().min(1),
    clientSecret: zod_1.z.string().min(1),
});
exports.PaymentInterSchema = zod_1.z.object({
    my_number: zod_1.z.string().min(1).optional(),
    creditor_name: zod_1.z.string().min(1, { message: 'Nome do credor inválido' }),
    cpf_or_cnpj: string_fns_1.cpfCnpjValidator.optional().nullable(),
    amount: zod_1.z.number().min(0.01, { message: 'Valor inválido' }),
    transfer: zod_1.z.discriminatedUnion('type', [common_1.TransferByAccountSchema, common_1.TransferByPixKeySchema]),
    payroll_checkout_id: zod_1.z.number().optional(),
});
exports.RequestInterSchema = zod_1.z.object({
    bankCode: zod_1.z.enum([back_code_1.BANK_CODES.inter, back_code_1.BANK_CODES.inter_2]),
    context: zod_1.z.object({
        type: zod_1.z.literal('api_inter'),
        data: InterApiContextSchema,
    }),
    payments: zod_1.z.array(exports.PaymentInterSchema).min(1),
});
